export default {
    loadEventNews: function (eventId, news, fetchTime) {
        return {
            type: 'EVENT_NEWS_LOADED',
            eventId,
            news,
            fetchTime
        };
    }
};
